
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcValveAnalogTwoWayIcon as ObcValveAnalogTwoWayIconElement} from '@oicl/openbridge-webcomponents/dist/automation/valve-analoge-two-way-icon/valve-analog-two-way-icon.js';
 
 
 

 
 export const ObcValveAnalogTwoWayIcon = createComponent({
   react: React,
   tagName: 'obc-valve-analog-two-way-icon',
   elementClass: ObcValveAnalogTwoWayIconElement,
   events: {
     
   }
  });
 
 